import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { applyTheme, isProd, LOGIN_CHANNEL, logoutClearSession, SessionKeys, UserIsLoggedIn } from '../utils/AppUtils';
import { setUserPremium, setUserRole, userDetailBroker } from '../redux/user/actions';
import { loginBroker, loginBrokerClear, loginClear } from '../redux/auth/actions';
import CONFIG from '../utils/config';
import $ from "jquery";
import axios from 'axios';
import API_LIST from '../utils/apiList';
import { myCart } from '../redux/Cart/actions';
import { fetchSubscribedData } from '../redux/checkout/actions';
import { getLoginLogo, getLoginLogoClear, getSmartBar, getSmartBarClear, setGoogleClientIdClear } from '../redux/home/actions';
import { useAuth } from '../utils/auth';
import SimplePopup from '../components/modal/SimplePopup';
import ShimmerScreen from '../components/Layouts/ShimmerScreen';
import Loader from '../components/Loader/Loader';

const GoogleAuthCall = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authProvider = useAuth();

  const loginLogo = useSelector((state) => state.home.loginLogo);


  const [authData, setAuthData] = useState(null);
  const [confirmModal, setConfirmModal] = useState(false);
  const [showModalMsg, setShowModalMsg] = useState("");
  const [isLoading,setIsLoading] = useState(true);

  const [loginImage, setLoginImage] = useState("//images/finwell-img/banner.png")
  const [companyLogo, setCompanyLogo] = useState("");

  const [loginType, setLoginType] = useState(0); //to be change name
 

  useEffect(() => {
    const domainArray = window.location.host.split('.');
  const subDomain = isProd()? domainArray[0]+"."+domainArray[1] : domainArray[0];;
  setIsLoading(true);
      dispatch(
        getLoginLogo({
          URL: `${CONFIG.API_URL_BROKER_ADMIN}${API_LIST.BROKER_API.LOGIN_LOGO_URL}`,
          payload: {
            company_ref: subDomain,
          },
          isJSON: true,
          method: "post",
        })
      );
  }, []);

  useEffect(() => {
    if (!_.isEmpty(loginLogo)) {
      setIsLoading(false)
      if (
        loginLogo.status === "success" &&
        !_.isEmpty(loginLogo.payload?.data)
      ) {
        let data = loginLogo.payload.data.sso_response;
        setCompanyLogo(loginLogo.payload.data.company_logo);
        if (loginLogo.payload.data.login_image_url) {
          setLoginImage(loginLogo.payload.data.login_image_url);
        }
        if (data?.is_sso_enabled === "1") {
          if (!_.isEmpty(data?.ms) && data?.ms?.is_enabled === "1") {
            window.open(data?.ms?.url, "_self");
          } else {
            if(!_.isEmpty(data?.google?.url)){
            window.open(data?.google?.url, "_self");
            }else{
            navigate("/");
          }
          }
        } else {
          setLoginType(1);
          navigate("/");
        }
      } else {
        setCompanyLogo("");
        navigate("/");
      }
      
      

    }
  }, [loginLogo]);
  

  return (
    <><Loader start={isLoading} />
   
      <SimplePopup
        confirmModal={confirmModal}
        setConfirmModal={setConfirmModal}
        showModalMsg={showModalMsg}
        isRightIcon={true}
      />
    </>
  );
};

export default GoogleAuthCall;
